var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSignal, Show } from 'solid-js';
import { Button, Container, Input, Label, Message } from '../../UI';
function UpdatePassword(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f;
    var _g = createSignal(''), password = _g[0], setPassword = _g[1];
    var _h = createSignal(''), error = _h[0], setError = _h[1];
    var _j = createSignal(''), message = _j[0], setMessage = _j[1];
    var _k = createSignal(false), loading = _k[0], setLoading = _k[1];
    var handlePasswordReset = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var error;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    setError('');
                    setMessage('');
                    setLoading(true);
                    return [4 /*yield*/, props.supabaseClient.auth.updateUser({
                            password: password()
                        })];
                case 1:
                    error = (_b.sent()).error;
                    if (error)
                        setError(error.message);
                    else
                        setMessage((_a = props.i18n.update_password) === null || _a === void 0 ? void 0 : _a.confirmation_text);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (<form id="auth-update-password" onSubmit={handlePasswordReset}>
      <Container gap="large" direction={'vertical'} appearance={props.appearance}>
        <Container gap="large" direction="vertical" appearance={props.appearance}>
          <div>
            <Label for="password" appearance={props.appearance}>
              {(_b = (_a = props.i18n) === null || _a === void 0 ? void 0 : _a.update_password) === null || _b === void 0 ? void 0 : _b.password_label}
            </Label>
            <Input id="password" name="password" autofocus placeholder={(_d = (_c = props.i18n) === null || _c === void 0 ? void 0 : _c.update_password) === null || _d === void 0 ? void 0 : _d.password_input_placeholder} type="password" onkeyup={function (e) { return setPassword(e.currentTarget.value); }} appearance={props.appearance}/>
          </div>
          <Button type="submit" color="primary" loading={loading()} appearance={props.appearance}>
            {(_f = (_e = props.i18n) === null || _e === void 0 ? void 0 : _e.update_password) === null || _f === void 0 ? void 0 : _f.button_label}
          </Button>
        </Container>

        <Show when={message()}>
          <Message appearance={props.appearance}>{message()}</Message>
        </Show>
        <Show when={error()}>
          <Message appearance={props.appearance}>{message()}</Message>
        </Show>
      </Container>
    </form>);
}
export { UpdatePassword };
